$(function() {
    $('.js-flash').each(function(){
        Manogi.delayedCloseFlash($(this));
        Manogi.delayedOpenFlash($(this));
    });

    $(document).arrive('.js-flash', function() {
        Manogi.delayedCloseFlash($(this));
        Manogi.delayedOpenFlash($(this));
    });
});
